module.exports = __webpack_public_path__ + "img/00041.a1168afc.webp";